type DisabledIntegration = { name: string };

const noop = (): void => undefined;
const disabledIntegration = (): DisabledIntegration => ({ name: "disabled" });

export const init = noop;
export const addBreadcrumb = noop;
export const setUser = noop;
export const captureRouterTransitionStart = noop;
export const isEnabled = (): boolean => false;
export const captureException = (..._args: unknown[]): string => "";
export const captureUnderscoreErrorException = async (
  ..._args: unknown[]
): Promise<string> => "";
export const replayIntegration = disabledIntegration;
export const browserTracingIntegration = disabledIntegration;
export const httpClientIntegration = disabledIntegration;
export const captureConsoleIntegration = disabledIntegration;
export const browserProfilingIntegration = disabledIntegration;
